<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{ "CreateDownload" | localize }}
                </h4>
            </div>

           

            <div class="body">
                <div class="mb-6 toogle-container dropdown-box">
                    <label for="formNames">Select form</label>
                    <select class="form-control"
                            name="formNames"
                            [(ngModel)]="selectedItem"
                            id="formNames">
                        <option>{{l('AllocationActivity')}}</option>

                        <option *ngFor="let item of listForms" [ngValue]="item">{{item.name}}</option>
                    </select>
                </div>
                <div class="mb-6 toogle-container" *ngIf="selectedItem===l('AllocationActivity')">
                    <div
                        (click)="toogleAllState()"
                        class="toogle-option"
                        [ngClass]="{ 'active-toogle': all === false }"
                    >
                        {{ "ApprovedByMe" | localize }}
                    </div>
                    <div
                        (click)="toogleAllState()"
                        class="toogle-option"
                        [ngClass]="{ 'active-toogle': all === true }"
                    >
                        {{ "All" | localize }}
                    </div>
                </div>

                <bs-daterangepicker-inline
                    (bsValueChange)="onDateValueChange($event)"
                    [bsConfig]="bsConfig"
                    [bsValue]="bsInlineRangeValue"
                ></bs-daterangepicker-inline>
            </div>

            <div class="footer">
                <button
                    (click)="close()"
                    class="btn font-weight-bold"
                    type="button"
                >
                    {{ "Cancel" | localize }}
                </button>
                <button
                    (click)="download()"
                    [disabled]="!bsInlineRangeValue.length"
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                    {{ "Download" | localize }}
                </button>
            </div>
        </div>
    </div>
</div>

<a #fileDownloader [style.display]="'none'"></a>
